
<script>
import axios from 'axios'
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import nfsaidaForm from './nfsaida-form'
import nfseForm from './nfse-form'
import nfentradaForm from './nfentrada-form'
import { apiDownloadPDF, apiDownload, apiDownloadFile, urlORDS, apiORDSpost, apiDateORDS } from '../shared/api-functions'
import { getText, formatDate, formatValue } from '../shared/utils'
import { objectToCsv, downloadCsvReport } from '../shared/csvReport'
import { SysVars } from '../main'

import autorizaNFe from '../api/api-nfe.js'



export default {
  data() {
    return {
      showForm: false, //exibe a tela de manutencao de nota de saida
      showFormNfse: false, //exibe a tela de manutencao de nota de saida
      showFormImportXML: false, //tela de manutencao de nota de entrada
      crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
      filter: '',
      metadata: this.$store.getters.getEntities.metadata,
      params: { outrasSaidas: true, codnf: 0, codpedv: 0 },
      filtroAvancado: {
        periodo: {
          label: 'Data da venda',
          varios: false,
          data_inicio: null,
          data_termino: null,
        },

        filtros: [
          { nome: 'clientefornecedor', label: null, url: null, varios: true, values: [] },
        ],

      },


      filterList: [], //lista de filtros aplicados que são exibidos em tela
      moreActionsBarList: [],
      incluirActionsBarList: [],
      monthFilter: {},
      operacao: {},
      title: '',
      titlePl: '',
      errmessagesDownloadXML: null,
      noFiles: false,
    }
  },

  mixins: [autorizaNFe],

  computed: {
    showVideo: function () {
      return (SysVars.appNFe && this.nfList.length == 0 && SysVars.appTrial)
    },
    nfList: function () {
      return this.$store.getters.getNfList
    },
    nf_with_itemList: function () {
      return this.$store.getters.getNf_with_itemList
    },

    inutList: function () {
      return this.$store.getters.getNfAvisos
    },
    inutCount: function () {
      if (this.$store.getters.getNfAvisos.length)
        return this.$store.getters.getNfAvisos[0].inutcount
      else
        return null
    },
    nfCount: function () {
      if (this.$store.getters.getNfAvisos.length)
        return this.$store.getters.getNfAvisos[0].nfcount
      else
        return null
    },
    url: function () {
      return this.$route.params.operacao
    },
    acessoCore: function () {
      return this.$store.getters.getEnvAcessoCore
    },
  },

  watch: {
    url: function () {
      this.operacao = this.url //operacao 'entrada' ou 'saida'
      this.updateActions()
      this.handleTitle()
      this.loadData()
    }
  },

  methods: {
    handleEdit(codnf, importXml, tpnf, responseImport) {
      //abre a tela de edicao
      this.crud = SysVars.crudU //operacao de edicao
      this.params = { codnf: codnf } //codigo da nf
      let self = this
      this.$nextTick(function () {
        if (importXml) {
          self.params.importXml = true
          self.params.responseImport = responseImport
          self.showFormImportXML = true; //exibe o form de manutencao da nota de entrada
        } else {
          if (tpnf == 'S') {
            self.showFormNfse = true
          } else {
            self.showForm = true; //exibe o form de manutencao da nota de saida
          }
        }
      })
    },

    handleTitle() {
      if (this.operacao == 'entrada') {
        this.title = 'Nota de Entrada'
        this.titlePl = 'Notas de Entrada'
      } else if (this.operacao == 'servico') {
        this.title = 'Nota de Serviço'
        this.titlePl = 'Notas de Serviço'
      }
      else {
        this.title = 'Nota de Saída'
        this.titlePl = 'Notas de Saída'
      }
    },

    handleView(nf) {
      //abre a tela de edicao
      this.crud = SysVars.crudView //visualizacao
      this.params = { codnf: nf.codnf } //codigo da nf
      let self = this
      this.$nextTick(function () {
        if (nf.impxml == 'S' && nf.stnf == '00') {
          self.params.importXml = true
          self.showFormImportXML = true; //exibe o form de manutencao da nota de entrada
        } else {
          if (nf.tpnf == 'S') {
            self.showFormNfse = true
          } else {
            self.showForm = true; //exibe o form de manutencao da nota de saida
          }
        }
      })
    },

    handleAction(act, codnf) {
      if (act == 10) {
        this.$router.push('/banking?codnf=' + codnf)
      }
    },

    async downloadArquivosXMLPeriodo(gerarArquivos) {
      var ref = {
        datareferencia: this.monthFilter.startDate,
        gerarArquivos: gerarArquivos
      }

      const response = await apiDownload(this, 'print/xmlfiles/', ref, 'post', true)

      //A RESPOSTA PODE SER O ARQUIVO .ZIP OU A LISTA DE ERROS

      let self = this
      self.noFiles = false

      if (response.headers['content-type'].includes('json')) {
        let blob = new Blob([response.data], { type: 'text/json' })
        let reader = new FileReader()
        reader.onload = function () {
          let obj = JSON.parse(reader.result)
          self.errmessagesDownloadXML = obj.errmessages
          self.noFiles = obj.noDataFound
        }
        reader.readAsText(blob)
      } else {
        apiDownloadFile(response)
      }

    },

    handleActionBarList(act) {
      if (act == 0) {
        //efetua download dos xmls de nfe no periodo selecionado
        this.downloadArquivosXMLPeriodo()
      }
      if (act == 1) {
        //efetua importacao do xml de nf-e
        this.handleImportarXMLNFe()
      }
      if (act == 2) {
        //exportar a lista de notas para planilha
        const data = this.nfList.map(nf => ({
          data: this.data(nf.data),
          datalancamento: this.data(nf.datalancamento),
          serie: nf.serie,
          numeronf: nf.nf,
          operacao: this.operacaoNf(nf.operacaonf),
          natureza: nf.descricao,
          nome: nf.nome,
          total: formatValue(nf.totger, 2),
          chave: nf.chave,
          status: nf.status,
          cfop: nf.cfop,
          totmer: formatValue(nf.totmer, 2),
          bcpis: formatValue(nf.bcpis, 2),
          totpis: formatValue(nf.totpis, 2),
          bccofins: formatValue(nf.bccofins, 2),
          totcofins: formatValue(nf.totcofins, 2),
          bcipi: formatValue(nf.bcipi, 2),
          totipi: formatValue(nf.totipi, 2),
          totipidevol: formatValue(nf.totipidevol, 2),
          bcicm: formatValue(nf.bcicm, 2),
          toticm: formatValue(nf.toticm, 2),
          bcicmst: formatValue(nf.bcicmst, 2),
          toticmst: formatValue(nf.toticmst, 2),
          totii: formatValue(nf.totii, 2),
        }))
        const csv = objectToCsv(data)
        downloadCsvReport(csv)
      }
      if (act == 4 || act == 5 || act == 6 || act == 7 || act == 8 || act == 10) {
        this.handleNew(act == 6, act == 8, act == 10)  //act == 6 => venda livre
      }
      if (act == 3) {
        this.$router.push('/pedido/novo')
      }
      if (act == 9) {
        //exportar a lista de notas para planilha
        this.loadDataDetails();
        const data = this.nf_with_itemList
        const csv = objectToCsv(data)
        downloadCsvReport(csv)
      }

    },

    PDFResponseCallbackSAT(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO SAT
      if (response.status != 'success') {
        this.$erpToastError(response.message)
      }

    },


    handlePDF(nf) {
      //impressao da danfe em PDF
      if (nf.esp == '59') {
        let paramsimp = '&codnf=' + nf.codnf
        this.$executaExtensaoChromeSAT(nf.codnf, 'imp', this.PDFResponseCallbackSAT, paramsimp)
        return
      }

      apiDownloadPDF(this, 'print/danfe/' + nf.codnf)
    },

    handleDownloadXML(codnf, chave) {
      //visualizacao do XML da NFE
      var data = { codnf: codnf, chave: chave, tipo: 'NFE' }
      apiDownload(this, 'print/xmlnfe/', data, 'post')
    },

    handlePreDANFE(nf) {
      //impressao da danfe em PDF
      apiDownloadPDF(this, 'print/previewdanfe/' + nf.codnf)
    },

    NFeResponseCallbackSAT(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO SAT
      if (response.status != 'success') {
        this.$erpToastError(response.message)
      } else {
        if (response.response.nf.length > 0 && response.response.nf[0].cstat == '100') {
          this.$erpToastSuccess('NFe Autorizada')
        }
        else {
          this.$erpToastError(response.response.xmotivo)
        }
      }
      this.loadData()
    },

    NFeResponseCallbackA1(response) {
      this.loadData()
    },

    NFeResponseCallbackA3(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
      if (response.status != 'success') {
        this.$erpToastError(response.message)
      } else {
        if (response.response.nf.length > 0 && response.response.nf[0].cstat == '100') {
          this.$erpToastSuccess('NFe Autorizada')
        }
        else {
          this.$erpToastError(response.response.xmotivo)
        }
      }
      this.loadData()
    },


    async handleAutoriza(nf) {
      //envia nf para autorizacao conforme tipo de certificado

      if (nf.emicnpj == '11111111111111') {
        this.$erpToastError('Em período de trial não é possível autorizar, será exibida a pré-visualização da DANFE.')
        this.handlePreDANFE(nf);
      } else {

        nf.xmotivo = ''
        if (nf.esp == '59') {
          this.autorizaNFeSAT(nf, this.NFeResponseCallbackSAT)

        } else {
          let tipo = this.$certificadoCheck(nf.codfil)
          if (tipo == 'A1') {
            this.autorizaNFeA1(nf, this.NFeResponseCallbackA1)
          } else
            if (tipo == 'A3') {
              this.autorizaNFeA3(nf, this.NFeResponseCallbackA3)
            }
        }
      }
    },


    getActions(nf) {
      var moreActions = []
      var act = {}
      let stnf = nf.stnf
      if (stnf == '10') {
        act = { action: 2, label: 'Danfe PDF' }
        moreActions.push(act)
        act = { action: 6, label: 'Download do XML' }
        moreActions.push(act)
        // if (nfev && nfev.length > 0) {
        //     act = { action: 9, label: 'Gerar PDF da CC-e' }
        //     moreActions.push(act)
        //     act = { action: 10, label: 'Enviar Email da CC-e' }
        //     moreActions.push(act)
        // }
      }
      if (stnf == '01') {
        act = { action: 7, label: 'Autorizar NF-e' }
        moreActions.push(act)
      }

      return moreActions
    },

    handleChangeAdvancedFilter(filtro) {
      var arrUrl = []

      var urlFilter = ''
      if (filtro.periodos && filtro.periodos.length > 0) {
        if (filtro.periodos[0].startDate && filtro.periodos[0].endDate) {
          urlFilter = '{"datalancamento":{"$between":[{"$date":"' + apiDateORDS(filtro.periodos[0].startDate) + '"},{"$date":"' + apiDateORDS(filtro.periodos[0].endDate, true) + '"}]}}'
          arrUrl.push(urlFilter)
        }
      }


      urlFilter = ''
      if (filtro.clientefornecedor && filtro.clientefornecedor.length > 0) {
        for (let x = 0; x < filtro.clientefornecedor.length; x++) {
          if (urlFilter != '') {
            urlFilter = urlFilter + ','
          }
          urlFilter = urlFilter + '{"codpart":{"$eq":"' + filtro.clientefornecedor[x] + '"}}'
        }
        if (urlFilter != '') {
          urlFilter = '{"$or":[' + urlFilter + ']}'
          arrUrl.push(urlFilter)
        }

      }

      let url = ''
      for (let i = 0; i < arrUrl.length; i++) {
        if (i != 0) {
          url = url + ','
        }
        url = url + arrUrl[i]
      }
      if (url != '')
        url = '{"$and":[' + url + ']}'


      this.filter = url
      this.loadData()
    },


    handleChangeFilter(url) {
      //aplicação do filtro avancado
      this.filter = url
      this.loadData()
    },

    handleNew(vendaLivre, vendaNfce, entradaArmazenamento) {
      //abre a tela de edicao
      this.crud = SysVars.crudI //operacao de inclusao
      this.params.codnf = 0
      this.params.outrasSaidas = true
      this.$store.dispatch('cleanpart')
      if (this.operacao == 'entrada') {
        this.params.operacaoNf = 'E'
        this.params.entradaArmazenamento = entradaArmazenamento
      } else if (this.operacao == 'servico') {
        this.params.operacaoNf = 'S'
      } else {
        this.params.operacaoNf = 'S'
        this.params.vendaLivre = vendaLivre || vendaNfce
        this.params.vendaNfce = vendaNfce
      }
      this.showFormNfse = false
      this.showForm = false
      if (this.operacao == 'servico') {
        this.showFormNfse = true
      }
      else {
        this.showForm = true
      }
    },


    closeForm() {
      this.showForm = false
      this.showFormNfse = false
      this.showFormImportXML = false
      this.loadData()
      this.$scrollTo(0)
    },

    editEntrada(codnf, importacaoxml) {
      this.showForm = false
      this.showFormNfse = false
      this.handleEdit(codnf, importacaoxml)
    },

    handleSearch(value) {
      //efetua a pesquisa
      this.filter = '{"$or":[{"nome":{"$like":"%25' + value + '%25"}},{"fantasia":{"$like":"%25' + value + '%25"}},{"nf":{"$eq":"' + value + '"}}]}'
      this.loadData()
    },

    loadData() {
      this.$store.dispatch('loadNfAvisos') //avisos de inutilizacao pendentes
      this.$store.dispatch('loadNfList', { operacao: this.operacao, filter: this.filter })
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    loadDataDetails() {
      this.$store.dispatch('loadNf_with_itemList', { operacao: this.operacao, filter: this.filter })
    },


    updateActions() {
      //AÇÕES DO BOTAO INCLUIR
      if (this.operacao == 'entrada') {
        this.incluirActionsBarList = [
          { action: 1, label: 'Importar XML de NF-e' },
          { action: 5, label: 'Incluir Outras Notas' },
          { action: 10, label: 'Incluir Nota Armazenamento' },
        ]
      } else if (this.operacao == 'servico') {
        this.incluirActionsBarList = [
          { action: 7, label: 'Incluir Serviço' },]
      } else {
        this.incluirActionsBarList = [
          // { action: 3, label: 'Venda com pedido' },
          { action: 6, label: 'Venda Sem Pedido' },
          { action: 8, label: 'Nota Fiscal Consumidor NFC-e' },
          { action: 4, label: 'Outras Operações' },
        ]
      }
    },

    textST(value) {
      if ((this.metadata) && (this.metadata.nf))
        return getText(value, this.metadata.nf.stnf)
    },

    operacaoNf(value) {
      return getText(value, this.metadata.nf.operacaonf)
    },

    data(value) {
      return formatDate(value)
    },

    handleImportarXMLNFe() {
      //SELECIONA ARQUIVO XML PARA IMPORTACAO DA NF DE ENTRADA
      this.$refs.xmlFile.value = ''
      this.$refs.xmlFile.click()
    },

    handleUploadXML() {
      //ENVIA O ARQUIVO XML SELECIONADO PARA EFETUAR IMPORTACAO
      var files = this.$refs.xmlFile.files
      if (files.length == 0) {
        return
      }

      var self = this

      let file = files[0]
      let formData = new FormData()
      formData.append(file.name, file)
      let modulo = 'invoice/importxml/'
      axios.post(urlORDS(this.$store, modulo), formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }
      ).then(function (response) {
        if (response.data.errmessages) {
          self.$erpToastError('Erro na importação da XML: ' + response.data.errmessages[0])
        } else {
          let codnf = response.data.codnf
          self.handleEdit(codnf, true, null, response.data)
          self.$erpToastSuccess('O XML foi importado com sucesso.')
        }
      })
      // .catch(function(response){
      // self.$erpToastError(response.data.errmessages)
      // })

    },

    async apiInvoice(p_nf, close, autorizacao) {

      let nf = await this.loadNf(p_nf.codnf);

      if (nf && nf.stnf !== '02') {

        //efetua a gravacao da nota fiscal
        var sendData = {}
        sendData.nf = { ...nf }
        if (autorizacao)
          sendData.autorizaenvio = true

        let metodo = 'post'
        let update = false
        if (nf.codnf != null) {
          update = true
        }

        var modulo = 'invoice/nf/'

        const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
        if (data.items) {
          nf = data.items[0]
          if ((nf.validation) && (nf.validation.errmessages) && (nf.validation.errmessages.length > 0)) {
            this.$erpToastError('Validação da nota: ' + nf.validation.errmessages[0])
            return false
          } else {
            if (update) {
              if (close) {
                return
              }
            }
          }
        }

      }
      if (autorizacao)
        this.handleAutoriza(nf)
    },


    async loadNf(codnf) {

      let nf = {};

      console.log(codnf)

      await this.$store.dispatch('loadNf', { id: codnf })
      if (this.$store.getters.getNf) {
        nf = { ...this.$store.getters.getNf[0] }

      }

      console.log(nf)

      return nf;
    },

    async handleAutorizaNF(nf) {
      this.apiInvoice(nf, false, true)
    },


  },

  filters: {
    format: function (value) {
      return formatValue(value, 2)
    },

  },

  components: {
    BarList, BarGrid, nfsaidaForm, nfentradaForm, nfseForm
  },

  mounted() {
    this.filter = this.monthFilter.url //carrega as notas do mes corrente
    this.loadData()
  },

  created() {
    if (this.$route.params && this.$route.params.operacao) {
      this.operacao = this.$route.params.operacao //operacao 'entrada' ou 'saida'
      this.handleTitle()
    }

    this.moreActionsBarList = [
      { action: 0, label: 'Gerar Arquivos XML Período' },
      { action: 2, label: 'Exportar Para Planilha' },
      { action: 9, label: 'Notas e Itens Exportar Para Planilha' },
    ]

    this.updateActions()

    this.showForm = false
    this.showFormNfse = false

    this.ambienteHomologacaoNFe()
    //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA


  }

}

</script>

<template>
  <div>
    <div id="list" v-show="!showForm && !showFormNfse && !showFormImportXML">
      <bar-list :refresh-button="true" :new-button="true" :filter-button="true" :pdf-button="false" :xls-button="false"
        :filter-month="true" :adv-filters-object="filtroAvancado" :field-month="'datalancamento'" :single-entity="title"
        :plural-entity="titlePl" :moreActions="moreActionsBarList" :incluirActions="incluirActionsBarList"
        :month-filter="monthFilter" @action="handleActionBarList" @search="handleSearch" @new="handleNew"
        @refresh="loadData" @filter="handleChangeFilter" @advancedfilter="handleChangeAdvancedFilter"
        title-search="Pesquise pelo número da nota ou pelo nome do cliente/fornecedor">

      </bar-list>

      <div v-if="inutCount > 0" class="row col mt-2">
        <span class="badge badge-red">Existem inutilizações pendentes a serem enviadas</span>
      </div>

      <div v-if="nfCount > 0" class="row col mt-2">
        <span class="badge badge-red">Existem notas fiscais pendentes a serem enviadas</span>
      </div>

      <div class="default-container mt-2">
        <alert v-if="nfList.length == 0" type="norecord"></alert>

        <div v-if="showVideo && operacao != 'entrada' && operacao != 'servico'"
          class="mt-5 mb-5 row col justify-content-center">
          <iframe width="560" height="315" src="//www.youtube.com/embed/kxjxOHP8rRs" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
            style="max-width: 800px"></iframe>
        </div>

        <div class="mainbox" v-for="nf in nfList" v-bind:key="nf.codnf">
          <div class="box">
            <div class="row">
              <div class="col-md-4 col-12">
                <span class="lbl-title-produto w-100">{{ nf.nome }}</span>
                <span class="data-list">{{ nf.cnpjcpf | formatCNPJCPF }}</span>
                <span class="data-list">{{ nf.uf }}</span>
              </div>
              <div class="col-md-2 col-12">
                <label class="lbl-list w-md-100 w-auto">Série/Número/Data</label>
                <span class="data-list">{{ nf.serie }} - {{ nf.nf }}</span>
                <span class="data-list">{{ nf.data | formatData }}</span>
              </div>
              <div class="col-md-2 col-12" v-if="operacao != 'servico'">
                <label class="lbl-list w-100">Natureza</label>
                <span class="data-list">{{ nf.descricao }}</span>
              </div>
              <div class="col-md-2 col-2">
                <label class="lbl-list w-100">Total</label>
                <span class="data-list d-flex">R$ <strong>{{ nf.totger | formatValue(2) }}</strong></span>
              </div>
              <div class="col-md-2 col-6 mb-2">
                <!-- <span class="data-list">{{ operacaoNf(nf.operacaonf) }}</span> -->
                <span v-if="nf.tpnf == 'S'" class="float-right badge badge-blue">NFS-e</span>
                <span v-if="nf.esp == '65'" class="float-right badge badge-blue">NFC-e</span>
                <span v-if="nf.esp == '59'" class="float-right badge badge-blue">SAT</span>
                <span class="float-right badge"
                  :class="[{ 'badge-green': nf.stnf == '10' || nf.stnf == '11' }, { 'badge-orange': nf.stnf == '00' }, { 'badge-orange': nf.stnf == '03' }, { 'badge-blue': nf.stnf == '01' }, { 'badge-red': nf.stnf == '90' || nf.stnf == '92' || nf.stnf == '50' }]">{{
                      textST(nf.stnf)
                  }}</span>
                <span v-if="nf.carta_correcao > 0" class="float-right badge badge-yellow mr-1">CC-e</span>
                <span v-if="nf.entradaarmazenamento == 'S'" class="float-right badge badge-gray mr-1">NF Armazenamento</span>
                <span v-if="(nf.operacaonf == 'E' && nf.movest == 'S' && nf.flagarmazenada != 'S')"
                  class="float-right badge badge-yellow mr-1">Não Armazenada</span>

              </div>
              <div class="col-md-4 col-8" v-if="nf.chave">
                <div data-toggle="tooltip" data-placement="top" title="Último XML enviado para a Receita">
                  <label class="lbl-list">Chave</label><span class="data-list" :style="{color: nf.stnf != '10' ? 'gray' : ''}">{{ nf.chave }}</span>
                </div>
                <span v-if="nf.stnf != '10' && nf.xmotivo" class="error w-100">{{ nf.xmotivo }}</span>
              </div>
              <div class="col-md-2 col-4" v-if="nf.npedido">
                <label class="lbl-list w-100">Pedido</label>
                <span class="data-list">{{ nf.npedido }}</span>
              </div>
              <div class="col-md-6 col-12 ml-auto">
                <bar-grid
                  :options="{ barNF: true, stnf: nf.stnf, chave: nf.chave, autoriza: (nf.emissaopropria === 'S' && nf.tpnf != 'S') }"
                  :moreActions="getActions(nf)" @view="handleView(nf)"
                  @edit="handleEdit(nf.codnf, nf.impxml == 'S', nf.tpnf)" @xml="handleDownloadXML(nf.codnf, nf.chave)"
                  @print="handlePDF(nf)" @send="handleAutorizaNF(nf)" @action="handleAction($event, nf.codnf)">
                </bar-grid>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

    <!-- INPUT PARA IMPORTACAO DO XML -->
    <div v-show="false" class="row">
      <input type="file" ref="xmlFile" accept=".xml" @change="handleUploadXML()">
    </div>

    <!-- FORMULARIO DE EDICAO DA NF DE SAIDA -->
    <transition name="fade">
      <nfsaida-form v-if="showForm" :params="params" :crud="crud" @closeform="closeForm" @edit="editEntrada">
      </nfsaida-form>
    </transition>

    <!-- FORMULARIO DE EDICAO DA NF DE SERVICO -->
    <transition name="fade">
      <nfse-form v-if="showFormNfse" :params="params" :crud="crud" @closeform="closeForm" @edit="editEntrada">
      </nfse-form>
    </transition>


    <!-- MENSAGENS DE ERRO DA GERACAO DOS ARQUIVOS XML -->
    <div class="nb-modal-scrollable" v-if="errmessagesDownloadXML">
      <div class="container nb-modal-scrollable-container" style="width: 800px; max-width: 100%">
        <div class="nb-modal-header">
          <h4 class="def-title">Não foi possível efetuar a geração</h4>
          <button type="button" class="close" @click="errmessagesDownloadXML = null" data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="nb-modal-scrollable-body">
          <div class="row col mb-2">
            Algumas pendências foram encontradas impossibilitando a geração dos arquivos XML do período
          </div>
          <validation title="Erros de Validação" :messages="errmessagesDownloadXML"></validation>
        </div>
        <div class="modal-footer" v-if="!noFiles">
          <v-button label="Efetuar Download" title="" :nb-btdef="true" @click="downloadArquivosXMLPeriodo(true)">
          </v-button>
          <v-button label="Cancelar" title="" @click="errmessagesDownloadXML = null"></v-button>
        </div>
      </div>
    </div>

    <!-- FORMULARIO DE EDICAO DA NF ENTRADA -->
    <transition name="fade">
      <nfentrada-form v-if="showFormImportXML" :params="params" :crud="crud" @closeform="closeForm"></nfentrada-form>
    </transition>
  </div>
</template>


<style>

</style>



// WEBPACK FOOTER //
// src/forms/nf-list.vue